import React, {Fragment} from 'react'
const NotFound = () => (
    <Fragment>
        <h1>Not found!</h1>
    </Fragment>
)

export default NotFound